
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import LoginForm from "./LoginForm";

const LoginSheet = () => {
  const [showLogin, setShowLogin] = useState(false);

  return (
    <div className="absolute top-4 right-4 z-30">
      {!showLogin ? (
        <Button 
          onClick={() => setShowLogin(true)}
          variant="outline" 
          size="icon" 
          className="bg-black/30 backdrop-blur-lg border-primary/20 hover:bg-black/40"
        >
          <Menu className="h-5 w-5 text-primary" />
        </Button>
      ) : (
        <div className="animate-fade-in relative">
          <div className="absolute -right-4 -top-4 w-[400px]">
            <LoginForm 
              onLoginSuccess={() => setShowLogin(false)} 
              onClose={() => setShowLogin(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginSheet;
